import { useTranslation } from "react-i18next";

const PromptsSuggestion = ({ data, showPrompts, setShowPrompts, handlePromptClick, primary }) => {

    // console.log(data);
    const { t } = useTranslation();

    const language = localStorage.getItem('language') || 'en';

    return (
        <div className={`propmpt-suggestion-ct relative bottom-[0px] w-full px-3 bg-white pt-1 mt-0 transition ease-in-out duration-700 ${ showPrompts && data?.length > 0 ? 'que-popup-ct-shows' : 'que-popup-ct-hide' }`}>
            <div className="flex items-center justify-between mt-2 mb-[13px]">
                <p className={`mb-0 text-[16px] font-semibold text-${language == 'ar' ? 'right': 'left'}`}>{t('Try asking')}</p>
                <div className="cursor-pointer" onClick={() => setShowPrompts(false)}>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 1L1 13" stroke={primary} />
                        <path d="M1 1L13 13" stroke={primary} />
                    </svg>
                </div>
            </div>
            <div className="max-h-[120px] overflow-auto">
                {data && data.map((item)=>
                    <div key={item.id} className="bg-[#ffffff] border border-[#e9e9e9] rounded-[5px] px-[10px] py-[7px] my-2 cursor-pointer" onClick={() => {handlePromptClick(item?.Question)}}>
                        <p className={`text-[13px] mb-0 text-${language == 'ar' ? 'right': 'left'}`}>{item?.Question}</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default PromptsSuggestion;